import React from 'react';
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import {KeyboardDatePicker} from "@material-ui/pickers";
import PropTypes from "prop-types";

const DefaultDatePicker = (props) => {
    return (
        <KeyboardDatePicker
            variant="inline"
            format="dd.MM.yy"
            minDate={props.minValue}
            placeholder={props.label}
            label={props.label}
            value={props.date}
            onChange={props.setDate}
            KeyboardButtonProps={{
                'aria-label': 'change date',
            }}
            keyboardIcon={<CalendarTodayIcon className="datepicker-icon"/>}
        />
    );
}

DefaultDatePicker.propTypes = {
    minValue: PropTypes.any,
    label: PropTypes.string,
    date: PropTypes.any,
    setDate: PropTypes.func
}

export default DefaultDatePicker;
